/**
 * Intervalli di polling dell'app, in un posto solo.
 *
 * PERCHÉ CENTRALIZZATI: erano sparsi in 14 punti, e la dispersione aveva già
 * prodotto un'incoerenza reale. Cinque componenti chiedevano
 * `/api/messages/unread` con intervalli diversi (30s, 30s, 30s, 10s, 15s), e
 * React Query per una stessa chiave usa **l'intervallo più aggressivo fra gli
 * osservatori attivi**: il contatore girava quindi a 10 secondi mentre tre
 * commenti nel codice dichiaravano "30 seconds - more efficient". Nessuno può
 * accorgersene leggendo un file alla volta.
 *
 * PERCHÉ QUESTI VALORI: il polling è il carico continuo dell'app — gira per ogni
 * utente connesso, che stia scrivendo o no. Misurato: a 2000 utenti simulati un
 * COUNT su indice da 0,05 ms impiegava 1,26 s, cioè il 90% del tempo era attesa
 * in coda sull'event loop di Node (single thread). Il collo di bottiglia è il
 * NUMERO di richieste, non il loro costo.
 *
 * I valori qui sotto portano il carico da 1,125 a 0,658 richieste/s per utente
 * con la chat aperta (-41%), il che a parità di macchina significa ~1,7x utenti.
 *
 * COSA NON PEGGIORA: i messaggi arrivano via WebSocket, che invalida già le
 * query interessate (vedi useWebSocket). Il polling è la rete di sicurezza per
 * quando la socket cade, non il canale principale. Per questo i contatori
 * possono permettersi 30 secondi, mentre i messaggi di una conversazione aperta
 * restano più frequenti.
 */

/** Lista conversazioni. Il WebSocket la invalida all'arrivo di un messaggio. */
export const POLL_CONVERSATIONS = 5_000;

/** Messaggi della conversazione aperta: il più visibile, resta frequente. */
export const POLL_MESSAGES = 8_000;

/** Stato online del partner in chat (fallback al push WebSocket). */
export const POLL_PARTNER_STATUS = 5_000;

/** Elenco notifiche nella pagina dedicata. */
export const POLL_NOTIFICATIONS = 15_000;

/**
 * Contatori dei non letti (badge di messaggi e notifiche).
 *
 * Un valore solo per entrambi, di proposito: sono la stessa esigenza e finiscono
 * negli stessi componenti. Averli separati è ciò che aveva permesso a un
 * osservatore a 10 secondi di trascinare tutti gli altri.
 */
export const POLL_UNREAD_COUNTS = 30_000;

/** Profilo completo di un utente: cambia di rado. */
export const POLL_USER_PROFILE = 30_000;
